export default __webpack_public_path__ + "static/media/logo.921fef37.svg";